import React from 'react';
import ReactDOM from 'react-dom';

class KnockoutReactBinding {
    constructor(ko) {
        this.init()
    }

    init() {
        ko.bindingHandlers.react = {
            init: function () {
                return {controlsDescendantBindings: true};
            },

            update: function (el, valueAccessor, allBindings) {
                var Component = ko.unwrap(valueAccessor());
                var props = ko.toJS(allBindings.get('props'));

                // Tell react to render/re-render
                ReactDOM.render(React.createElement(Component, props), el);
            }
        }
    }
}

function initKoReactSocket(ko) {
    return new KnockoutReactBinding(ko);
};

export default initKoReactSocket;